<template>
  <div class="main-page">
    <div class="container">
      <AppBar
        title="Anamnesa"
        :previousLink="previousLink" />

      <div class="mb-4 mt-3 px-2 pt-3">
    <Loading v-if="loading.mcu" />
    <Empty v-else-if="listPertanyaan.length === 0" :message="'Saat ini belum ada pertanyaan untuk ditampilkan.'"/>
    <div v-else>
      <div v-for="pertanyaan in listPertanyaan" :key="pertanyaan.id_pertanyaan" class="card border-0 shadow-sm rounded-3 p-3 mb-4">
        <span class="fs-18 fw-700 color-neutral-900 mb-3 d-block">{{ pertanyaan.pertanyaan ?? 'Covid-19 Status:' }}</span>
        <div v-for="jawaban in pertanyaan.jawaban" :key="jawaban.id_jawaban" class="w-100 my-2 px-0">
          <!-- Ini Checkbox -->
          <div v-if="jawaban.format === 'checkbox'"
            class="card-info p-3 d-flex flex-row align-items-center border-0 justify-content-between shadow-sm"
            :class="{'bg-primary-50':jawabanUser[jawaban.name], 'bg-neutral-100':!jawabanUser[jawaban.name]}"
          >
            <label v-if="jawaban.format === 'checkbox'" class="form-check-label fs-12 fw-400 pe-3" :for="`opt-${jawaban.name}`"
              :class="{'color-primary-500':jawabanUser[jawaban.name], 'color-neutral-900':!jawabanUser[jawaban.name]}">
              {{ jawaban.name.includes('tidakada') ? `Tidak ada ${pertanyaan.pertanyaan.toLowerCase()} di bawah ini`:jawaban.label }}
            </label>

            <input
              class="cursor-pointer"
              :type="formatType(jawaban.format)"
              :class="{
                'form-check-input':(jawaban.format === 'checkbox'),
                'form-control':!(jawaban.format === 'checkbox')
              }"
              :id="`opt-${jawaban.name}`"
              :name="pertanyaan.name"
              :value="jawaban.label"
              v-model="jawabanUser[jawaban.name]"
              :data-name-jawaban="jawaban.name"
              :disabled="isDisabled(jawaban.name)"
              @click="checkTidakAda(pertanyaan.name, jawaban.name, $event)"
            >
          </div>

          <!-- Ini Text -->
          <div v-else-if="jawaban.format === 'text'">
            <input class="form-control form-capsule shadow-sm" type="text" :placeholder="jawaban.label" :aria-label="jawaban.label" :name="pertanyaan.name" v-model="jawabanUser[jawaban.name]" :data-name-jawaban="jawaban.name" :disabled="isDisabled(jawaban.name)">
          </div>

          <!-- Ini Combo Box -->
          <div v-else-if="jawaban.format === 'combobox'" class="w-100">
            <select :name="jawaban.name" v-model="jawabanUser[jawaban.name]" class="form-select form-capsule" :aria-label="jawaban.label" :class="{'color-neutral-500':!jawabanUser[jawaban.name]}">
              <option value="" disabled>{{ jawaban.label }}</option>
              <option v-for="comboVal in jawaban.combo_val" :key="comboVal.value" :value="comboVal.value">
                {{ comboVal.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Ini TTD -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="fs-18 fw-700 color-neutral-900">Tanda Tangan</span>
        <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill btn-hapus fs-12 color-neutral-600" @click="deleteSignature">Hapus</button>
      </div>
      <VueSignaturePad
        :options="{
          onBegin: () => {$refs.ttdUser.resizeCanvas()}
        }"
        class="w-100 bg-white mx-auto signature-pad shadow-sm"
        id="ttd"
        height="250px"
        ref="ttdUser"
        @mouseup="updateSignature"
      />

      <small class="text-muted d-block mt-2">Gunakan jari untuk tanda tangan pada area di atas.</small>

      <span v-if="errorMessage" class="invalid-feedback d-block mt-2">{{ errorMessage }}</span>

      <!-- Bagian Submit -->
      <button class="btn btn-primary btn-login w-100 mt-4 shadow-sm" data-bs-toggle="modal" data-bs-target="#modalPreview">Selanjutnya</button>

      <!-- Modal -->
      <div class="modal fade" id="modalPreview" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title fw-700">Preview Jawaban</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="desc-group mt-3 mt-md-0">
                <div v-for="pertanyaan in listPertanyaan" :key="pertanyaan.id_pertanyaan">
                  <span class="fs-18 fw-700 color-neutral-900 mb-3">{{ pertanyaan.pertanyaan ?? 'Covid-19 Status:' }}</span>
                  <div class="table-responsive">
                    <table class="table table-striped align-middle mb-0">
                      <tbody>
                        <tr v-for="jawaban in pertanyaan.jawaban" :key="jawaban.id_jawaban">
                          <td class="w-75">{{ jawaban.label }}</td>
                          <td>
                            <span v-if="jawabanUser[jawaban.name] === true">Ya</span>
                            <span v-else-if="jawabanUser[jawaban.name] === false">Tidak</span>
                            <span v-else>{{ jawabanUser[jawaban.name] }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <span class="fs-18 fw-700 color-neutral-900 mb-3 d-block">Tanda Tangan</span>
                  <img v-if="formattedTtdUser" :src="formattedTtdUser" alt="tanda-tangan" class="w-100">
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-between gap-2">
              <button type="button" class="btn btn-danger col py-2" data-bs-dismiss="modal">Batal</button>
              <button type="button" class="btn btn-primary col py-2" @click="prepareSubmit">Kirim</button>
            </div>
          </div>
        </div>
      </div>

      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import AppBar from '@/components/AppBar.vue'
import Loading from '@/components/utility/Loading'
import Empty from '@/components/utility/Empty'
import { onMounted, ref, nextTick, computed, watch } from 'vue'
import { getAnamnesaPoli, loading, listAnamnesaPoli, submitAnamnesaPoli } from '@/core/poli'
import { user, token } from '@/core/auth'
import { DataURIToBlob, showNotif } from '@/core/utility'
import { useRoute, useRouter } from 'vue-router'

export default {
  components: { AppBar, Loading, Empty },
  setup () {
    const router = useRouter()
    const listPertanyaan = ref([])
    const idOrder = ref(null)
    const jawabanUser = ref({})
    const ttdUser = ref(null)
    const errorMessage = ref('')
    const formattedTtdUser = ref(null)
    const route = useRoute()
    const anamnesaCode = computed(() => route.params.anamnesaCode)

    const previousLink = computed(() => {
      if (idOrder.value) {
        return { name: 'ProfilOrderDetail', params: { id_order: idOrder.value } }
      }
      return '/profile/order'
    })

    const formatType = (type) => {
      if (type === 'radiobutton') {
        return 'radio'
      }

      return type
    }

    const updateSignature = () => {
      formattedTtdUser.value = ttdUser.value.saveSignature('image/png').data
    }

    const deleteSignature = () => {
      ttdUser.value.clearSignature()
      formattedTtdUser.value = null
    }

    const updateRadio = (pertanyaan, jawaban) => {
      for (let i = 0; i < listPertanyaan.value.length; i++) {
        if (listPertanyaan.value[i].name === pertanyaan) {
          for (let j = 0; j < listPertanyaan.value[i].jawaban.length; j++) {
            if (listPertanyaan.value[i].jawaban[j].name === jawaban) {
              jawabanUser.value[listPertanyaan.value[i].jawaban[j].name] = true
            } else {
              jawabanUser.value[listPertanyaan.value[i].jawaban[j].name] = false
            }
          }
        }
      }
    }

    const checkTidakAda = async (pertanyaan, jawaban, element) => {
      // cek apakah yg dipilih 'tidak ada'
      if (jawaban.includes('tidakada')) {
        const allElements = document.getElementsByName(pertanyaan)
        // cek apakah checked
        if (element.target.checked) {
          for (let i = 0; i < allElements.length; i++) {
            if (!allElements[i].getAttribute('data-name-jawaban').includes('tidakada')) {
              if (allElements[i].getAttribute('data-name-jawaban').includes('lainya')) {
                jawabanUser.value[allElements[i].getAttribute('data-name-jawaban')] = ''
              } else {
                jawabanUser.value[allElements[i].getAttribute('data-name-jawaban')] = false
              }
              allElements[i].disabled = true
            }
          }
        } else { // jika uncheck
          for (let i = 0; i < allElements.length; i++) {
            if (!allElements[i].getAttribute('data-name-jawaban').includes('tidakada')) {
              allElements[i].disabled = false
            }
          }
        }
      }
    }

    const isDisabled = (jawaban) => {
      let temp = jawaban.split('_')
      temp = temp[0] + '_' + temp[1] + '_tidakada'

      if (!jawaban.includes('tidakada')) {
        nextTick(() => {
          const elements = document.querySelectorAll(`[data-name-jawaban='${temp}']`)
          if (elements.length && elements[0].checked) {
            document.querySelectorAll(`[data-name-jawaban='${jawaban}']`)[0].disabled = true
          }
        })
      }
    }

    const prepareSubmit = async () => {
      // Inject ttd nya
      if (ttdUser.value && !ttdUser.value.isEmpty()) {
        jawabanUser.value.ttd = DataURIToBlob(ttdUser.value.saveSignature('image/png').data)
      } else {
        errorMessage.value = 'Tanda tangan wajib diisi'
        const modal = Modal.getOrCreateInstance(document.querySelector('#modalPreview'))
        modal.toggle()
        return
      }

      // Inject id pendaftar
      jawabanUser.value.id_pendaftar = user.value.id

      // Inject anamnesa_code
      jawabanUser.value.anamnesa_code = anamnesaCode.value

      // Inject no_pendaftaran
      jawabanUser.value.no_pendaftaran = idOrder.value

      // Inject pertanyaan
      jawabanUser.value.pertanyaan = 'anamnesa'

      // Inject token api
      jawabanUser.value.token_api = token.value

      // jadikan form data
      const fd = new FormData()
      const keys = Object.keys(jawabanUser.value)
      for (let i = 0; i < keys.length; i++) {
        // Cuma kirim yg ada isinya aja
        if (jawabanUser.value[keys[i]] !== false && jawabanUser.value[keys[i]] !== '') {
          if (keys[i] === 'ttd') { // kalau ttd ada penanganan khusus
            fd.append(keys[i], jawabanUser.value[keys[i]], 'ttd.png')
          } else {
            fd.append(keys[i], jawabanUser.value[keys[i]])
          }
        }
      }

      // Submit
      try {
        const modal = Modal.getOrCreateInstance(document.querySelector('#modalPreview'))
        modal.toggle()
        const result = await submitAnamnesaPoli(fd)
        if (result.status) {
          showNotif({
            status: 'success',
            message: 'Anamnesa berhasil disimpan'
          })
          setTimeout(() => {
            router.replace(previousLink.value)
          }, 800)
        } else {
          showNotif({
            status: 'error',
            message: result.message
          })
        }
      } catch (error) {
        let msg = 'Gagal kirim data'
        if (error.response?.data?.message) {
          msg = error.response.data.message
        }

        showNotif({
          status: 'error',
          message: msg
        })
      }
    }

    onMounted(async () => {
      // Persist and restore id_order so back link survives refreshes
      const storedId = window.localStorage.getItem('anamnesa-poli-order.' + anamnesaCode.value)
      const queryId = route.query?.id_order
      if (queryId) {
        window.localStorage.setItem('anamnesa-poli-order.' + anamnesaCode.value, queryId)
        idOrder.value = queryId
      } else if (storedId) {
        idOrder.value = storedId
      }

      await getAnamnesaPoli(anamnesaCode.value)

      if (window.localStorage.getItem('anamnesa-poli.' + anamnesaCode.value)) {
        jawabanUser.value = JSON.parse(window.localStorage.getItem('anamnesa-poli.' + anamnesaCode.value))
      } else {
        for (let i = 0; i < listAnamnesaPoli.value.length; i++) {
          jawabanUser.value[listAnamnesaPoli.value[i].name] = listAnamnesaPoli.value[i].pertanyaan
          for (let j = 0; j < listAnamnesaPoli.value[i].jawaban.length; j++) {
            let tempJawaban = false
            if (listAnamnesaPoli.value[i].jawaban[j].format === 'text' || listAnamnesaPoli.value[i].jawaban[j].format === 'combobox') {
              tempJawaban = ''
            }
            jawabanUser.value[listAnamnesaPoli.value[i].jawaban[j].name] = tempJawaban
          }
        }
        window.localStorage.setItem('anamnesa-poli.' + anamnesaCode.value, JSON.stringify(jawabanUser.value))
      }

      listPertanyaan.value = listAnamnesaPoli.value
    })

    watch(jawabanUser, (newValue) => {
      window.localStorage.setItem('anamnesa-poli.' + anamnesaCode.value, JSON.stringify(newValue))
    }, { deep: true })

    return {
      loading,
      listPertanyaan,
      formatType,
      jawabanUser,
      prepareSubmit,
      updateRadio,
      ttdUser,
      checkTidakAda,
      isDisabled,
      errorMessage,
      updateSignature,
      formattedTtdUser,
      deleteSignature,
      previousLink
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-login {
  border: none;
  padding: 10px 20px;
}

.card-info {
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}

.form-check-input:checked {
  border: none;
}

.form-select {
  border: 1px solid #E2E8F0;
}

.form-control.form-capsule, .form-select.form-capsule {
  border-radius: 12px;
  padding: 8px 14px;
  min-height: 40px;
}

.signature-pad {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
}

.btn-hapus {
  padding: 8px 20px;
  background: #F7FAFC;
  border-radius: 100px;
  padding: 8px 20px;
}

.invalid-feedback {
  font-size: 12px;
}
</style>
